var _style, _desc, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyFirst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 44",
    style: {
      enableBackground: "new 0 0 46 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8E8E8;}\n\t.st1{fill:#FFAF10;}\n\t.st2{fill:#EF9614;}\n\t.st3{fill:#FFD00D;}\n\t.st4{fill:#EF8318;}\n\t.st5{fill:#DB722C;}\n\t.st6{fill:#A05F33;}\n\t.st7{fill:#87502A;}\n\t.st8{fill:#30631A;}\n\t.st9{fill:#1F470D;}\n\t.st10{fill:#BF7E52;}\n\t.st11{fill:#C95E23;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:#FF7058;}\n\t.st14{fill:#FFD15C;}\n\t.st15{fill:#F1543F;}\n\t.st16{fill:#F8B64C;}\n\t.st17{fill:#746442;}\n\t.st18{font-family:'Arial-BoldMT';}\n\t.st19{font-size:10.6154px;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_x2F_trophy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trophy"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "st0",
    cx: 20,
    cy: 22.5,
    rx: 20,
    ry: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M21.3,30v-4.7c-0.2,0-0.4,0.1-0.6,0.1h-1.9c-0.2,0-0.4,0-0.6-0.1V30H21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st2",
    d: "M19.7,30.6V26h-0.6c-0.1,0-0.3,0-0.4-0.1v4.7H19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st3",
    d: "M19.7,23.9c-1.1,0-2.1-0.2-3-0.6v0.4c0,1.2,1,2.2,2.2,2.2h1.8c1.2,0,2.2-1,2.2-2.2v-0.4 C21.8,23.7,20.8,23.9,19.7,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st1",
    d: "M19.3,23.9c-0.9-0.1-1.8-0.2-2.6-0.5v0.4c0,1.2,1,2.2,2.3,2.2h1.9c0.1,0,0.3,0,0.4,0 C20.2,25.7,19.4,24.9,19.3,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    className: "st4",
    d: "M23.3,32.1v-1.6c0-0.3-0.2-0.5-0.4-0.5h-5.7c-0.2,0-0.4,0.2-0.4,0.5v1.6H23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    className: "st5",
    d: "M19.3,32.1v-1.6c0-0.3,0.2-0.5,0.4-0.5h-2.6c-0.2,0-0.4,0.2-0.4,0.5v1.6H19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    className: "st6",
    d: "M27.3,39.4v-6.8c0-0.2-0.2-0.4-0.4-0.4H12.6c-0.2,0-0.4,0.2-0.4,0.4v6.8H27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    className: "st7",
    d: "M13.3,39.4v-6.8c0-0.2,0.2-0.4,0.4-0.4h-1.1c-0.2,0-0.4,0.2-0.4,0.4v6.8H13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    className: "st8",
    d: "M25.8,37.4c0,0.2-0.2,0.4-0.4,0.4H15.1c-0.2,0-0.4-0.2-0.4-0.4v-3.3c0-0.2,0.2-0.4,0.4-0.4 h10.3c0.2,0,0.4,0.2,0.4,0.4V37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    className: "st9",
    d: "M16.3,37.4v-3.3c0-0.2,0.2-0.4,0.4-0.4h-1.6c-0.2,0-0.4,0.2-0.4,0.4v3.3 c0,0.2,0.2,0.4,0.4,0.4h1.6C16.5,37.8,16.3,37.6,16.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    className: "st10",
    d: "M29.5,39.4H10.5c-0.2,0-0.4,0.2-0.4,0.4v0.7C13,42.1,16.4,43,20,43s7-0.9,9.9-2.5v-0.7 C29.9,39.6,29.7,39.4,29.5,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    className: "st1",
    d: "M33.5,2.1h-3.2v0.7c0,0.2-0.1,0.3-0.3,0.3h-1.4c0,0-0.1,0-0.1,0.1v1h4.4 c-0.2,3.6-1.8,6.9-4.4,9.2v1.3c0,0.5,0,1-0.1,1.4c4-2.8,6.6-7.4,6.6-12.6C34.9,2.7,34.3,2.1,33.5,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    className: "st3",
    d: "M11.5,14.6v-1.3C9,11,7.3,7.8,7.2,4.1h4.4v-1c0,0,0-0.1-0.1-0.1h-1.4C9.9,3.1,9.7,3,9.7,2.8 V2.1H6.5c-0.8,0-1.4,0.6-1.4,1.4c0,5.2,2.6,9.8,6.6,12.6C11.6,15.6,11.5,15.1,11.5,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    className: "st4",
    d: "M11.1,3.1v11.6c0,5,4,9.1,8.9,9.1s8.9-4.1,8.9-9.1V3.1H11.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.139241, 3.108434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_14_",
    className: "st5",
    d: "M1.7,11.7V0H0v11.7c0,5,3.9,9,8.8,9c0.3,0,0.6,0,0.9,0C5.2,20.2,1.7,16.4,1.7,11.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_1_",
    className: "st5",
    cx: 8.9,
    cy: 9.8,
    rx: 5.8,
    ry: 6.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_15_",
    className: "st11",
    d: "M15.7,13c0-3.2,2.2-5.8,5.1-6.2c-0.2,0-0.5-0.1-0.7-0.1c-3.2,0-5.8,2.8-5.8,6.2 s2.6,6.2,5.8,6.2c0.3,0,0.5,0,0.7-0.1C17.9,18.7,15.7,16.1,15.7,13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16_",
    className: "st3",
    d: "M22,17.1c-0.1,0-0.2,0-0.3-0.1l-1.6-0.9c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0L18.3,17 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.3-0.1-0.5l0.3-1.9c0-0.1,0-0.2-0.1-0.3l-1.3-1.3 c-0.2-0.2-0.2-0.4-0.2-0.6c0.1-0.2,0.2-0.3,0.5-0.4l1.8-0.3c0.1,0,0.2-0.1,0.2-0.2l0.8-1.7c0.1-0.2,0.3-0.4,0.5-0.4 s0.4,0.1,0.5,0.4l0.8,1.7c0,0.1,0.2,0.2,0.2,0.2l1.8,0.3c0.2,0,0.4,0.2,0.5,0.4c0.1,0.2,0,0.4-0.2,0.6l-1.3,1.3 c-0.1,0.1-0.1,0.2-0.1,0.3l0.3,1.9c0,0.2,0,0.4-0.1,0.5C22.3,17,22.2,17.1,22,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17_",
    className: "st1",
    d: "M18.9,16.3l0.3-2c0-0.1,0-0.3-0.1-0.3l-1.5-1.4c-0.2-0.2-0.2-0.4-0.2-0.6L16.7,12 c-0.2,0-0.4,0.2-0.5,0.4s0,0.4,0.2,0.6l1.3,1.3c0.1,0.1,0.1,0.2,0.1,0.3l-0.3,1.8c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.2,0.2,0.4,0.2 c0.1,0,0.2,0,0.3-0.1l0.6-0.3C18.9,16.6,18.9,16.4,18.9,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_18_",
    className: "st3",
    d: "M30.4,2.7c0,0.2-0.2,0.4-0.4,0.4H9.5c-0.2,0-0.4-0.2-0.4-0.4V0.4C9.1,0.2,9.3,0,9.5,0H30 c0.2,0,0.4,0.2,0.4,0.4V2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_19_",
    className: "st1",
    d: "M11.7,2.7V0.4c0-0.2,0.2-0.4,0.4-0.4H9.5C9.3,0,9.1,0.2,9.1,0.4v2.3c0,0.2,0.2,0.4,0.4,0.4 h2.6C11.9,3.1,11.7,2.9,11.7,2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_20_",
    className: "st3",
    d: "M9.6,27.5c-0.1,0-0.2-0.1-0.2-0.2c-0.5-1.4-0.8-1.7-2.1-2.2c-0.1,0-0.2-0.1-0.2-0.2 s0.1-0.2,0.2-0.2c1.3-0.5,1.7-0.8,2.1-2.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2c0.5,1.4,0.8,1.7,2.1,2.2 c0.1,0,0.2,0.1,0.2,0.2s-0.1,0.2-0.2,0.2c-1.3,0.5-1.7,0.8-2.1,2.2C9.8,27.4,9.7,27.5,9.6,27.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(13.164557, 2.590361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_21_",
    className: "st12",
    d: "M16.7,22.5c-0.1,0-0.2-0.1-0.2-0.1c-0.4-1.1-0.7-1.4-1.8-1.8c-0.1,0-0.1-0.1-0.1-0.2 c0-0.1,0.1-0.2,0.1-0.2c1.1-0.4,1.4-0.7,1.8-1.8c0-0.1,0.1-0.1,0.2-0.1s0.2,0.1,0.2,0.1c0.4,1.1,0.7,1.4,1.8,1.8 c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.1,0.2c-1.1,0.4-1.4,0.7-1.8,1.8C16.8,22.4,16.7,22.5,16.7,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_22_",
    className: "st12",
    d: "M9.1,32.7H4.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h4.4c0.2,0,0.4,0.2,0.4,0.4 C9.5,32.5,9.3,32.7,9.1,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_23_",
    className: "st12",
    d: "M8.1,34.2H5.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h2.4c0.2,0,0.4,0.2,0.4,0.4 S8.4,34.2,8.1,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_24_",
    className: "st12",
    d: "M2,4.1C1.9,4.1,1.8,4,1.8,3.9C1.4,2.8,1.2,2.6,0.1,2.2C0.1,2.2,0,2.1,0,2 c0-0.1,0.1-0.2,0.1-0.2c1-0.4,1.3-0.6,1.7-1.7C1.8,0.1,1.9,0,2,0s0.1,0.1,0.2,0.1c0.4,1.1,0.6,1.4,1.7,1.7 c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.1,0.2c-1,0.4-1.3,0.6-1.7,1.7C2.1,4,2,4.1,2,4.1z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M30.1,38.5c-0.2,0.1-0.4,0.2-0.6,0.2c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0h-0.1c-0.1,0-0.2,0-0.3,0 c-0.7-0.2-1.1-1.2-1.5-2l-0.2-0.4c-0.2-0.4-0.5-0.8-0.8-1.1C26.2,35.1,26.1,35,26,35c0,0-0.1,0-0.1,0c-0.1-0.1-0.3-0.1-0.5-0.1 c0,0,0,0,0,0c-0.2,0-0.3-0.1-0.5-0.1h0c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0l-0.2,0c0,0,0,0,0,0l-0.4,0.6L20.5,40l5-1.2 l1.4,5.1l2.6-4.6L30.1,38.5L30.1,38.5z M42.2,35.1l-0.4-0.6c0,0,0,0,0,0l-0.2,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0.1-0.7,0.1h0 c-0.2,0-0.4,0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0-0.3,0.1-0.5,0.1c0,0-0.1,0-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.7,0.9-1.1,2.8-2.1,3.1c-0.1,0-0.2,0-0.3,0h-0.1c-0.1,0-0.2,0-0.2,0c0,0,0,0-0.1,0c-0.2,0-0.4-0.1-0.6-0.2l0.5,0.9l2.6,4.6 l1.4-5.1l5,1.2L42.2,35.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M43.6,23.1c-0.4-1.2,0.7-3.1,0-4.1c-0.7-1-2.9-0.6-3.9-1.3c-1-0.7-1.2-3-2.4-3.3c-1.1-0.4-2.7,1.3-3.9,1.3 c-1.3,0-2.8-1.6-3.9-1.3c-1.2,0.4-1.5,2.6-2.4,3.3c-1,0.7-3.2,0.3-3.9,1.3c-0.7,1,0.4,3,0,4.1c-0.4,1.1-2.4,2.1-2.4,3.4 s2,2.2,2.4,3.4c0.4,1.2-0.7,3.1,0,4.1c0.7,1,2.9,0.6,3.9,1.3c1,0.7,1.2,3,2.4,3.3c1.1,0.4,2.7-1.3,3.9-1.3c1.3,0,2.8,1.6,3.9,1.3 c1.2-0.4,1.5-2.6,2.4-3.3c1-0.7,3.2-0.3,3.9-1.3c0.7-1-0.4-3,0-4.1c0.4-1.1,2.4-2.1,2.4-3.4C46,25.2,43.9,24.3,43.6,23.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M29.3,38.9c-1.2-0.4-1.5-2.9-2.5-3.7c-0.6-0.5-1.8-0.5-2.7-0.7l-0.4,0.7c0.4,0.1,0.8,0.2,1.1,0.2 c0.6,0.1,1.2,0.2,1.5,0.4c0.3,0.2,0.6,0.9,0.8,1.5c0.4,0.9,0.9,2,1.8,2.3c0.2,0.1,0.4,0.1,0.6,0.1c0.1,0,0.3,0,0.4,0l0.5-0.9 C30.1,38.9,29.7,39,29.3,38.9L29.3,38.9z M39.7,35.2c-1,0.8-1.3,3.3-2.5,3.7c-0.4,0.1-0.8,0-1.3-0.2l0.5,0.9c0.1,0,0.3,0,0.4,0 c0.2,0,0.4,0,0.6-0.1c0.9-0.3,1.4-1.4,1.8-2.3c0.3-0.6,0.5-1.2,0.8-1.5c0.3-0.2,0.9-0.3,1.5-0.4c0.4-0.1,0.8-0.1,1.2-0.2 l-0.4-0.7C41.5,34.7,40.3,34.7,39.7,35.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M40.7,25.9c0,4-3.1,7.2-7.1,7.4c-0.1,0-0.2,0-0.3,0c-4,0-7.3-3.2-7.4-7.3v0c0,0,0-0.1,0-0.1 c0-4.1,3.3-7.4,7.4-7.4C37.3,18.5,40.7,21.8,40.7,25.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 30.208 30.1836)",
    className: "st17 st18 st19"
  }, "1"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyFirst);
export default __webpack_public_path__ + "static/media/trophy-first.8854415526fc60e872305f53317b08cc.svg";
export { ForwardRef as ReactComponent };